import React from "react";
import {
//   BrowserRouter as Router,
  useParams,
} from "react-router-dom";
import BlockDiagrams from './BlockDiagrams';
import SystemModeling from './SystemModeling';
import Linearization from './Linearization';
import FirstOrderResponse from "./FirstOrderResponse";
import SteadyStateError from "./SteadyStateError";
import PIDControl from "./PIDControl";
import CascadeControl from "./CascadeControl";
import BodePlots from "./BodePlots";
import NyquistCriterion from "./NyquistCriterion";
import GainAndPhase from "./GainAndPhase";
import RootLocus from "./RootLocus";
import StateSpace from "./StateSpace";
import Controllability from "./Controllability";
import StateFeedback from "./StateFeedback";
import LuenbergerObserver from "./LuenbergerObserver";
import KalmanFilter from "./KalmanFilter";
import PredictiveControl from "./PredictiveControl";
import AdaptiveControl from "./AdaptiveControl";

const ChangeComponents = {
    blockdiagrams: BlockDiagrams,
    systemmodeling: SystemModeling,
    linearization: Linearization,
    firstorderresponse: FirstOrderResponse,
    steadystateerror: SteadyStateError,
    pidcontrol: PIDControl,
    cascadecontrol: CascadeControl,
    bodeplots: BodePlots,
    nyquistcriterion: NyquistCriterion,
    gainandphase: GainAndPhase,
    rootlocus: RootLocus,
    statespace: StateSpace,
    controllability: Controllability,
    statefeedback: StateFeedback,
    luenbergerobserver: LuenbergerObserver,
    kalmanfilter: KalmanFilter,
    predictivecontrol: PredictiveControl,
    adaptivecontrol: AdaptiveControl,


  };

export default function Subtopics(props) {
    // The <Route> that rendered this component has a
    // path of `/topics/:topicId`. The `:topicId` portion
    // of the URL indicates a placeholder that we can
    // get from `useParams()`.
    let { topicId } = useParams();
    
    let MyComponent = ChangeComponents[topicId];
    return (
        <div>
            {/* {topicId} is for testing route names */}
            {/* <h3>{topicId}</h3> */}
            <MyComponent topicId={topicId}/>
      </div>
    );
  }